var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 30,
    viewBox: "0 0 69 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5303 16.4142C68.3113 15.6332 68.3113 14.3668 67.5303 13.5858L54.8023 0.85787C54.0213 0.0768207 52.7549 0.0768206 51.9739 0.857869C51.1929 1.63892 51.1929 2.90525 51.9739 3.6863L63.2876 15L51.9739 26.3137C51.1929 27.0948 51.1929 28.3611 51.9739 29.1421C52.7549 29.9232 54.0213 29.9232 54.8023 29.1421L67.5303 16.4142ZM0.297851 17L66.116 17L66.116 13L0.297852 13L0.297851 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconRight);
export default __webpack_public_path__ + "static/media/arrowIconRight.803ead60a24ac112aac5515b7ace0fbb.svg";
export { ForwardRef as ReactComponent };